import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Mail, Bell } from 'lucide-react';
import HebeMascot from './HebeMascot';

interface NavigationProps {
  onScrollToWaitlist: (e: React.MouseEvent) => void;
}

const Navigation: React.FC<NavigationProps> = ({ onScrollToWaitlist }) => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <nav className="flex items-center justify-between px-6 py-8 md:px-12">
      <div className="flex items-center gap-4">
        <Link to="/" className="flex items-center gap-4">
          <div className="cursor-pointer">
            <HebeMascot className="h-12 w-12" />
          </div>
          <span className="font-mono text-2xl font-black uppercase tracking-tight">hebe</span>
        </Link>
      </div>
      <div className="flex gap-8">
        <a
          href="mailto:careers@ohhebe.us"
          className="flex items-center gap-2 transition-colors hover:text-gray-400"
        >
          <Mail className="h-4 w-4" />
          <span>Careers</span>
        </a>
        {isHomePage && (
          <a
            href="#signup"
            onClick={onScrollToWaitlist}
            className="flex items-center gap-2 transition-colors hover:text-gray-400"
          >
            <Bell className="h-4 w-4" />
            <span>Get notified</span>
          </a>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
